import type { FC } from 'react';

import { StyledButton, StyledIcon } from './styled';

import { IconName } from '../Icon';

export interface IGoNextProps {
    onClickHandler: () => void;
}

export const GoNext: FC<IGoNextProps> = ({ onClickHandler }: IGoNextProps) => {
    return (
        <StyledButton onClick={onClickHandler}>
            Next
            <StyledIcon iconName={IconName.ARROW} />
        </StyledButton>
    );
};
